import { createRouter, createWebHistory } from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/customer-order-live-tracking-v1',
      name: 'customer-order-live-tracking-v1',
      component: () => import('../views/CustomerOrderLiveTrackV2/Index.vue')
    },
    {
      path: '/customer-order-live-tracking-mini-program-v1',
      name: 'customer-order-live-tracking-mini-program-v1',
      component: () => import('../views/CustomerOrderLiveTrackMiniProgramV1/Index.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/Privacy/Index.vue')
    },
    {
      path: '/submit-customer-info-h5-v1',
      name: 'submit-customer-info-h5-v1',
      component: () => import('@/views/SubmitCustomerInfoH5V1/Index.vue')
    },
    {
      path: '/submit-customer-info-mini-program-v1',
      name: 'submit-customer-info-mini-program-v1',
      component: () => import('@/views/SubmitCustomerInfoMiniProgramV1/Index.vue')
    },
    {
      path: '/driver-reset-password-v1',
      name: 'driver-reset-password-v1',
      component: () => import('@/views/DriverResetPasswordV1/Index.vue')
    },
    {
      path: '/verify-email-v1',
      name: 'verify-email-v1',
      component: () => import('@/views/VerifyEmailV1/Index.vue')
    },
    {
      path: '/android-download',
      name: 'android-download',
      component: () => import('@/views/AndroidDownload/Index.vue')
    },
    {
      path: '/driver-web-v1/login',
      name: 'driver-web-v1-login',
      component: () => import('@/views/DriverWebV1/Login.vue')
    },
    {
      path: '/driver-web-v1/register',
      name: 'driver-web-v1-register',
      component: () => import('@/views/DriverWebV1/Register.vue')
    },
    {
      path: '/driver-web-v1/home',
      name: 'driver-web-v1-home',
      component: () => import('@/views/DriverWebV1/Home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/driver-web-v1/task',
      name: 'driver-web-v1-task',
      component: () => import('@/views/DriverWebV1/Task.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/driver-web-v1/:pathMatch(.*)*',
      redirect: { name: 'driver-web-v1-home' }
    },
  ]
})

async function getCurrentUser() {
  const { auth } = await import('../views/DriverWebV1/services/firebase')
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe()
      resolve(user)
    })
  })
}

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    const user = await getCurrentUser()
    if (!user) {
      return {
        name: 'driver-web-v1-login',
        query: { redirect: to.fullPath }
      }
    }
    const { checkDriverRole } = await import('../views/DriverWebV1/services/firebase')
    const { isDriver, driverId } = await checkDriverRole(user)
    if (driverId) {
      localStorage.setItem('IDIRECT_DRIVER_PORTAL_V1_DRIVER_ID', String(driverId))
    }
    if (!isDriver) {
      const { auth } = await import('../views/DriverWebV1/services/firebase')
      await auth.signOut()
      return {
        name: 'driver-web-v1-login',
        query: { redirect: to.fullPath, error: 'role' }
      }
    }
  }
})

export default router
